import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Copy({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Copy.Outline {...props} /> : <Copy.Solid {...props} />;
}

Copy.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M16 13H16.2C17.7464 13 19 11.7464 19 10.2V3.8C19 2.2536 17.7464 1 16.2 1H9.8C8.2536 1 7 2.2536 7 3.8V4M3.8 19H10.2C11.7464 19 13 17.7464 13 16.2V9.8C13 8.2536 11.7464 7 10.2 7H3.8C2.2536 7 1 8.2536 1 9.8V16.2C1 17.7464 2.2536 19 3.8 19Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Copy.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 3.55C6 1.58939 7.58939 0 9.55 0H15.95C17.9106 0 19.5 1.58939 19.5 3.55V9.95C19.5 11.9106 17.9106 13.5 15.95 13.5H15.75C15.3358 13.5 15 13.1642 15 12.75C15 12.3358 15.3358 12 15.75 12H15.95C17.0822 12 18 11.0822 18 9.95V3.55C18 2.41782 17.0822 1.5 15.95 1.5H9.55C8.41782 1.5 7.5 2.41782 7.5 3.55V3.75C7.5 4.16421 7.16421 4.5 6.75 4.5C6.33579 4.5 6 4.16421 6 3.75V3.55ZM0 9.55C0 7.58939 1.58939 6 3.55 6H9.95C11.9106 6 13.5 7.58939 13.5 9.55V15.95C13.5 17.9106 11.9106 19.5 9.95 19.5H3.55C1.58939 19.5 0 17.9106 0 15.95V9.55ZM3.55 7.5C2.41782 7.5 1.5 8.41782 1.5 9.55V15.95C1.5 17.0822 2.41782 18 3.55 18H9.95C11.0822 18 12 17.0822 12 15.95V9.55C12 8.41782 11.0822 7.5 9.95 7.5H3.55Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
